import $ from "jquery";



const onFilterButtonClick = function(e) {
  e.stopPropagation();
  console.log("onFilterButtonClick2");
  if ($('body').hasClass("show-filters")) {
    $('body').removeClass("show-filters");
  } else {
    $('body').addClass("show-filters");
  }
}

const onFilterCloseButtonClick = function(e) {
  e.stopPropagation();
  console.log("onFilterCloseButtonClick");
  $('body').removeClass("show-filters");
}


const onSortButtonClick = function(e) {
  e.stopPropagation();
  console.log("onSortButtonClick");
  if ($('body').hasClass("show-sort")) {
    $('body').removeClass("show-sort");
  } else {
    $('body').addClass("show-sort");
  }
}

const onSortCloseButtonClick = function(e) {
  e.stopPropagation();
  console.log("onSortCloseButtonClick");
  $('body').removeClass("show-sort");
}






const onFilterHeadingClick = function(e) {
  e.stopPropagation();
  $(".filter").removeClass("filter--open");
  if ($(this).parent().hasClass("filter--open")) {
    $(this).parent().removeClass("filter--open")
  } else {
    $(this).parent().addClass("filter--open")
  }
  $(document).on("click", function(e){
    var $trigger = $(".filter__options");
    if($trigger !== e.target && !$trigger.has(e.target).length){
      $(".filter").removeClass("filter--open");
    }  
  });
}



const onFilterCheckboxClick = function(e) {
  e.stopPropagation();
  if (!this.checked) {
    $(this).parent().removeClass("active")
  } else {
    $(this).parent().addClass("active")
  }
}

const onSortRadioClick = function(e) {
  e.stopPropagation();
  let title = "Sort by "+$(this).data("title");
  $(".filter--sort").find('.radio').removeClass("active")
  $(".filter--sort").find('.filter__heading').text(title);
  $(this).parent().addClass("active");
}






const onFilterColourClick = function(e) {
  e.stopPropagation();
  //console.log("onFilterColourClick");
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).find("input").attr("checked",false);
  } else {
    $(this).addClass("active");
    $(this).find("input").attr("checked",true); 
  }
  $(this).find("input").trigger("change");

}





const onFilterChange = function(e) {
  console.log("onFilterCheckboxChange");
  e.preventDefault();
  updateSearchParams();
}





const updateSearchParams = function() {
  console.log("updateSearchParams");
  let searchParams = createSearchParams($('#CollectionFiltersForm')[0]);
  console.log("searchParams",searchParams);
  let pathname = window.location.pathname;
  renderResults(pathname+"?"+searchParams);
  updateURLHash(searchParams);
}





const createTags = function() {
  
  let searchParams = new URLSearchParams(location.search);
  $(".tags__list").empty();
  searchParams.forEach(function(value, key) {

    let input = $("input[value='"+value+"'][name='"+key+"']");
        input.attr("checked",true);
        input.parent().addClass("active");

    let label = input.data('name'); 

    if (key.indexOf("filter.")>=0 ) {
      $(".tags__list").append('<button class="tag" data-name="'+key+'" data-value="'+value+'">'+input.data('name')+'</button>');
    }

  });
  if ($(".tags__list").has( ".tag" ).length) {
    $('.tags').addClass("active");
  }
  $(".tag").on("click",deleteTag);
}




const deleteTag = function(e) {

  e.stopPropagation();

  let key   = $(this).data("name");
  let value = $(this).data("value");


  $(this).remove();

  let input = $("input[value='"+value+"'][name='"+key+"']");
      //input.parent().removeClass("active");
      input.trigger("click");



  if ($(".tags__list").children().length == 0) {
    $('.tags').removeClass("active");
  }

}




const onFilterSumbit = function(e) {
  console.log("onFilterSumbit");
}




const createSearchParams = (form) => {
  const formData = new FormData(form);
  return new URLSearchParams(formData).toString();
}




const onHistoryChange = (event) => {
  console.log("event.state", event.state);
  console.log("event.state.searchParams", event.state.searchParams);
}




const updateURLHash = (searchParams) => {
  history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

  if ($("#CollectionFiltersForm").length>0) {
    createTags();
  }
}




const renderResults = (url) => {

  //console.log("renderResults", url);

  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = responseText;
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    });
}






export const initFilters= function() {

  
  $('.filter__heading').on('click',onFilterHeadingClick);

  let _filterCheckbox = $('.checkbox input[type=checkbox]');
      _filterCheckbox.on('click',onFilterCheckboxClick);

  let _sortRadio = $('.radio input[type=radio]');
      _sortRadio.on('click',onSortRadioClick);

  let _filterColour = $('.colour');
      _filterColour.on('click',onFilterColourClick);

  let _filterInput = $('#CollectionFiltersForm input');
      _filterInput.on('change',onFilterChange);

  //$( "#CollectionFiltersForm" ).on('submit',onFilterSumbit);

  $('#filters-open').on('click',onFilterButtonClick);
  $('.filters__close-btn').on('click',onFilterCloseButtonClick);
  $('.filters__apply-btn').on('click',onFilterCloseButtonClick);

  $('#sort-open').on('click',onSortButtonClick);
  $('.sorting__close-btn').on('click',onSortCloseButtonClick);
  $('.sorting__apply-btn').on('click',onSortCloseButtonClick);

  

  let grid = window.localStorage.getItem('collection__grid');
  if (grid == "single") {
    $('#ProductGridContainer .collection__grid').addClass("collection__grid--single");
    $('#filters-columns').addClass("active"); 
  }
 
  window.addEventListener('popstate', onHistoryChange);

  createTags();


};